export const eventTypes = {
  0: 'Payment',
  1: 'Invoice',
  2: 'Note'
}
